import React from "react";
import { useTheme } from "styled-components";
import { Flex } from "reflexbox";
import { GenerateGUID } from "../../../modules/guid";

const Indicator = ({ active = false, id = GenerateGUID(), color }) => {
  const theme = useTheme();

  return (
    <Flex key={id} width={1} justifyContent="center">
      <div
        style={{
          width: "1rem",
          height: "1rem",
          borderRadius: "50%",
          border: `1px solid ${theme.borderColor}`,
          backgroundColor:
            active === true ? color || theme.success : color || theme.danger,
        }}
      />
    </Flex>
  );
};

export default Indicator;
